module.exports = __webpack_public_path__ + "img/defaultProfile.dca9fce6.png";